import { ReviewDftDraftFiling } from "components/ChatCard/DftFilingDraftCard/ReviewDftDraftFiling";
import { Button } from "components/DesignSystem/Button/Button";
import { SUBMITTED } from "constants/sensitiveData";
import { useModal } from "hooks/useModal";
import { CustomData } from "types/Models/reviewDocumentAndBalancingPayment";

export const ReviewDftFiling = ({
  customData,
  messageId,
  groupId,
}: {
  customData: CustomData;
  messageId: string;
  groupId: string;
}) => {
  const reviewDftDraftModal = useModal();
  const draftId = customData?.metadata?.dft_review_draft_id ?? "";
  const isSubmitted = customData.card_status === SUBMITTED;

  return (
    <div>
      <Button size="small" onClick={reviewDftDraftModal.open}>
        View
      </Button>
      {reviewDftDraftModal.isOpen && (
        <ReviewDftDraftFiling
          {...reviewDftDraftModal}
          draftId={draftId}
          groupId={groupId}
          isSubmitted={isSubmitted}
          rejectionReason={customData?.metadata?.rejection_reason ?? ""}
          approvalStatus={customData?.metadata?.is_approved ?? null}
          submittedBy={customData?.metadata?.submitted_by?.name ?? null}
          fileId={customData?.metadata?.file_id ?? ""}
          taxAmount={customData?.metadata?.tax_amount_payable ?? 0}
          grossAssetValue={customData?.metadata?.gross_asset_value ?? 0}
        />
      )}
    </div>
  );
};
